import { Box } from "@primer/react";
import clsx from "clsx";
import MyText from "../ui/text/Text";
import styles from "./DataGrid.module.css";
import { formatDisplay } from "./type/ColumnHelper";
import { IDataGridColumn, IDataGridFocusedCell } from "./type/IDataGridProps";
import TextWithEllipse from "../ui/text-with-ellipse";
interface ICellProps {
  column: IDataGridColumn;
  rowIndex: number;
  rowId: any;
  rowData: any;
  colIndex: number;
  stickyOffsets: any;
  focusedCell?: IDataGridFocusedCell;
  mainColor?: string;
}
const Cell = (props: ICellProps) => {
  const { column, rowId, rowData, colIndex, rowIndex, stickyOffsets } = props;
  const isFocused =
    column.isAllowFocus &&
    rowData["id"] === props.focusedCell?.focusedCell?.rowData["id"] &&
    props.focusedCell?.focusedCell?.dataField === column.dataField;
  const cellStyle = {
    width: column.width,
    minWidth: column.minWidth,
    fontWeight: column.isMainColumn ? "600" : 400,
    whiteSpace: "break-spaces" as const,
    textAlign: column.align,
    ...(rowData && { color: rowData.backgroundColor }),
    position: column.fixed ? "sticky" : "relative",
    left:
      column.fixed === "left"
        ? stickyOffsets.leftOffsets[column.uuid ?? ""]
        : undefined,
    right:
      column.fixed === "right"
        ? stickyOffsets.rightOffsets[column.uuid ?? ""]
        : undefined,

    zIndex: column.fixed ? 15 : 1,
    // background: column.fixed ? "red" : undefined,
    outline: isFocused
      ? `2px solid ${props.mainColor ?? "rgb(9, 105, 218)"}`
      : undefined,
    outlineOffset: isFocused ? "-2px" : undefined,
  };
  const handleFocus =
    column.isAllowFocus &&
      (column.dataField ?? column.id) &&
      props.focusedCell?.onFocusedCellChanged
      ? () =>
        props.focusedCell?.onFocusedCellChanged({
          rowData: rowData,
          dataField: column.dataField ?? column.id ?? "",
        })
      : undefined;
  if (column.id === "col_idx") {
    return (
      <td
        style={cellStyle}
        className={clsx(
          column.fixed ? styles.fixed : "",
          column.fixed === "left" ? styles.left : "",
          column.fixed === "right" ? styles.right : "",
          column.isLastColFixed ? styles.lastFixed : "",
          column.isAllowFocus &&
            rowData["id"] === props.focusedCell?.focusedCell?.rowData["id"] &&
            props.focusedCell?.focusedCell?.dataField === column.dataField
            ? styles.focused
            : "",
        )}
      >
        <Box>{rowIndex + 1}</Box>
      </td>
    );
  }
  if (column.cellRender) {
    return (
      <td
        key={colIndex}
        style={cellStyle}
        onFocus={handleFocus}
        tabIndex={column.isAllowFocus ? 0 : undefined}
        className={clsx(
          column.fixed ? styles.fixed : "",
          column.fixed === "left" ? styles.left : "",
          column.fixed === "right" ? styles.right : "",
          column.isLastColFixed ? styles.lastFixed : "",
          column.isAllowFocus &&
            rowData["id"] === props.focusedCell?.focusedCell?.rowData["id"] &&
            props.focusedCell?.focusedCell?.dataField === column.dataField
            ? styles.focused
            : "",
        )}
      >
        {column.cellRender(rowData)}
      </td>
    );
  }

  return (
    <td
      key={colIndex}
      style={cellStyle}
      className={clsx(
        column.fixed ? styles.fixed : "",
        column.fixed === "left" ? styles.left : "",
        column.fixed === "right" ? styles.right : "",
        column.isLastColFixed ? styles.lastFixed : "",
        column.isAllowFocus &&
          rowData["id"] === props.focusedCell?.focusedCell?.rowData["id"] &&
          props.focusedCell?.focusedCell?.dataField === column.dataField
          ? styles.focused
          : "",
      )}
      onFocus={handleFocus}
      tabIndex={column.isAllowFocus ? 0 : undefined}
    >
      {!column.isTextWithEllipseLine && (
        <>
          <MyText
            text={
              column.isHideZeroValue &&
                rowData[column.dataField ?? ""]?.toString() === "0"
                ? ""
                : formatDisplay(column,(rowData[column.dataField ?? ""]?.toString() ?? ""))
            }
          />
        </>
      )}
      {column.isTextWithEllipseLine && (
        <>
          <TextWithEllipse
            lineNumber={1}
            allowToggleText={true}
            text={
              column.isHideZeroValue &&
                rowData[column.dataField ?? ""]?.toString() === "0"
                ? ""
                : (rowData[column.dataField ?? ""]?.toString() ?? "")
            }
          />
        </>
      )}
    </td>
  );
};

export default Cell;
